import { Heading, Text, Box } from '@dapperlabs/core-fe';
import React from 'react';

interface Props {
  cardHeading: string;
  cardText: string;
  color: string;
  isDarkText: boolean;
}

export const AboutEventCard: React.FC<Props> = ({
  cardHeading,
  cardText,
  color,
  isDarkText,
}) => {
  return (
    <>
      <Text
        as='time'
        width='fit-content'
        px={2}
        color={isDarkText ? '#000000' : '#FFFFFF'}
        fontSize='21px'
        textTransform='uppercase'
        backgroundColor={color}
      >
        {cardText}
      </Text>
      <Heading
        as='h3'
        pt='0.8rem'
        pb='0.3rem'
        pl='0.5rem'
        fontFamily='heading'
        textTransform='uppercase'
      >
        {cardHeading}
      </Heading>
      <Box pos='absolute' right='-2px' bottom='-10px' color={color}>
        &gt;
      </Box>
    </>
  );
};
